import GraphQLIntrospectionResult from 'graphql-client/schema/GraphQLIntrospectionResult';

export default function getAllNodeNamesInSchema(): Array<string> {
  return (
    // eslint-disable-next-line no-restricted-syntax
    GraphQLIntrospectionResult.__schema.types
      // kind === 'OBJECT' as opposed to e.g. 'SCALAR', 'UNION', or 'INTERFACE'
      .filter(({name, kind}) => name !== 'Query' && !name.startsWith('__') && kind === 'OBJECT')
      .map((type) => type.name)
      .sort()
  );
}
